import React from 'react';
import { InputLabel } from '@material-ui/core';

import { DataTable } from 'shared';
import dayjs from 'utils/dayjsConfig';

function Donations({ classes, subscription }) {
    const columns = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Date', accessor: 'donatedAt' },
        { Header: 'Status', accessor: 'status' },
    ];
    const data = subscription.charges
        .filter((charge) => charge.status === 'DONATED' || charge.status === 'FAILED_TO_DONATE')
        .map((charge) => {
            charge.donatedAt = dayjs(charge.billedAt.date).format('MM/DD/YYYY');
            return charge;
        });

    return (
        <div className={classes.card}>
            <InputLabel className={classes.inputLabel}>Donations</InputLabel>
            <DataTable columns={columns} data={data} showPagination={data.length > 10} />
        </div>
    );
}

export { Donations };
